import { render, staticRenderFns } from "./FamiliareModal.vue?vue&type=template&id=0d327cc9&scoped=true&"
import script from "./FamiliareModal.vue?vue&type=script&lang=js&"
export * from "./FamiliareModal.vue?vue&type=script&lang=js&"
import style0 from "./FamiliareModal.vue?vue&type=style&index=0&id=0d327cc9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d327cc9",
  null
  
)

component.options.__file = "FamiliareModal.vue"
export default component.exports